import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, FormGroup } from 'reactstrap';
import { FMessage } from '../../hoc/IntlComponents';
import WarningBlock from './WarningBlock';

const SiteKeyBlock = ({type, api_key}) => {
  return (
    <div className="site-key-block">
      <p className="site-key-block-intro">
        <FMessage id={`transfer-by-api.sitekey.header.${type}`}/>
      </p>
      {api_key ?
        <div className='your-site-key'>
          <h6 className='title'>
            <b><FMessage id='transfer-by-api.sitekey.your'/></b>
          </h6>
          <h6 className='value'>
            <b>{api_key}</b>
          </h6>
        </div>
        :
        <Fragment>
          <Row className='request-api-btn'>
            <Col>
              <FormGroup>
                <Link
                  to={{
                    pathname: "/tickets/create",
                    search: "?sitekey=site_key",
                  }}
                  className="btn btn-primary btn-md outline"
                >
                  <FMessage id='transfer-by-api.sitekey.request.btn'/>
                </Link>
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              {type !== 'api' &&
                <Fragment>
                  <WarningBlock/>
                  <br/>
                </Fragment>
              }
              <FMessage id='transfer-by-api.sitekey.access.hint.p-1'/>
            </Col>
          </Row>
        </Fragment>
      }
    </div>
  );
};

export default SiteKeyBlock;
